// 읽지 못하는 폴더의 복구 명령을 만든다.
//
// 사용자가 명령을 그대로 복사해 터미널에 붙여 넣는다. 그래서 셸 인용은 안전 요건이다. 공백이
// 있는 폴더명을 인용하지 않으면 chown 이 다른 경로를 대상으로 실행된다.

// 폴더명을 알 수 없을 때 쓰는 자리표시자. 사용자가 직접 채운다.
const FOLDER_PLACEHOLDER = "<Dataset 폴더>";

// 인용 없이 써도 셸이 한 단어로 읽는 이름.
const BARE_NAME = /^[A-Za-z0-9._-]+$/;

export function buildChownCommand(folderName: string | null): string {
  return `chown -R $USER:$USER ${quoteShellArgument(folderName)}`;
}

function quoteShellArgument(folderName: string | null): string {
  if (folderName === null || folderName.trim() === "") {
    return FOLDER_PLACEHOLDER;
  }
  if (BARE_NAME.test(folderName)) {
    return folderName;
  }
  // 작은따옴표 안에서는 모든 문자가 리터럴이다. 이름에 있는 작은따옴표만 따로 이어 붙인다.
  return `'${folderName.split("'").join(`'\\''`)}'`;
}
